export function computeCustomForm(form, values, productPrice) {
  const fields = form?.fields || [];
  const vals = values || {};
  let extras = 0;
  let qty = 1;
  let pack = Number(productPrice || 0);
  let hasQty = false;
  const snapshot = [];
  for (const field of fields) {
    const raw = vals[field.id];
    if (field.type === "quantity") {
      hasQty = true;
      const opt = (field.options || []).find((o) => o.id === raw || o.label === raw) || (field.options || [])[0];
      if (!opt) {
        if (field.required) return { ok: false, error: `Select ${field.label}` };
        continue;
      }
      qty = Number(opt.qty || 1) || 1;
      pack = Number(opt.price || 0);
      snapshot.push({ label: field.label, value: opt.label, price: pack, qty });
      continue;
    }
    if (field.type === "paid_dropdown") {
      if (!raw) {
        if (field.required) return { ok: false, error: `Select ${field.label}` };
        continue;
      }
      const opt = (field.options || []).find((o) => o.id === raw || o.label === raw);
      if (!opt) return { ok: false, error: `Invalid ${field.label}` };
      extras += Number(opt.price || 0);
      snapshot.push({ label: field.label, value: opt.label, price: Number(opt.price || 0) });
      continue;
    }
    if (field.type === "paid_name") {
      const text = String(raw || "").trim();
      if (!text) {
        if (field.required) return { ok: false, error: `Enter ${field.label}` };
        continue;
      }
      extras += Number(field.price || 0);
      snapshot.push({ label: field.label, value: text, price: Number(field.price || 0) });
      continue;
    }
    if (field.type === "paid_image") {
      const url = String(raw || "").trim();
      if (!url) {
        if (field.required) return { ok: false, error: `Upload ${field.label}` };
        continue;
      }
      extras += Number(field.price || 0);
      snapshot.push({ label: field.label, value: url, price: Number(field.price || 0) });
    }
  }
  const line = Math.round((pack + extras) * 100) / 100;
  const q = hasQty ? qty : 1;
  return {
    ok: true,
    qty: q,
    unit_price: q ? Math.round((line / q) * 100) / 100 : line,
    line_total: line,
    snapshot,
  };
}

export function defaultFormValues(form) {
  const vals = {};
  for (const f of form?.fields || []) {
    if ((f.type === "quantity" || f.type === "paid_dropdown") && f.options?.[0]) {
      vals[f.id] = f.options[0].id;
    } else {
      vals[f.id] = "";
    }
  }
  return vals;
}

export function cartItemsPayload(items, country) {
  return {
    items: items.map((i) => ({
      product_id: i.product_id,
      variant_id: i.variant_id || null,
      qty: i.qty,
      custom_form: i.custom_form || null,
      custom_print: i.custom_print || null,
    })),
    country: country || undefined,
  };
}
